import { api } from "./client.js";
import type { AppConfig, ConfigResponse, PipelineMode } from "@cas/shared";

export const configApi = {
  get:    () => api.get<ConfigResponse>("manage/config").then(r => r.config),
  update: (config: AppConfig) => api.put<ConfigResponse>("manage/config", { config }).then(r => r.config),
  setMode: (pipelineMode: PipelineMode, reason?: string) =>
    api.put<{ pipelineMode: PipelineMode }>("manage/mode", { pipelineMode, reason }),
};
